import React from "react";
import "./styles.css";
export default function index() {
  return (
    <div className="home">
      <div className="home-header">
        <div className="home-header-title">
          <h1>Crown Steel Works</h1>
        </div>
      </div>
      <div className="home-body">
        <h2>Services we provide</h2>
        <hr />
        <p>
          Quaerat ullam cumque magni sed. Non possimus iste laudantium
          repudiandae repellendus sunt velit impedit. Et possimus enim pariatur.
          Voluptas impedit qui ut nesciunt temporibus omnis et qui.
          Reprehenderit tempore eos autem iste.
        </p>

        <p>
          Nesciunt aliquid esse in eum. Est voluptas iusto quidem reprehenderit
          molestiae deserunt minus dolorem. Itaque voluptas nulla excepturi
          culpa quo est neque velit. Autem beatae nam amet.
        </p>
        <br />
        <h2>Welding</h2>
        <hr />
        <p>
          Et sit aspernatur officia rem minima ut. Dolorem laudantium blanditiis
          sit nemo fugit odio dolore dolorum. Illum et nam qui consequatur est
          debitis et. Asperiores amet est et pariatur excepturi sequi harum
          rerum. Quisquam quaerat nobis autem ut impedit debitis. Quis est
          quisquam aut vitae.
        </p>

        <p>
          Quo perferendis maxime voluptate quo possimus. Ab rerum reiciendis et
          deleniti reprehenderit sint. Rerum est earum provident saepe quo
          dignissimos.
        </p>
        <br />
        <h2>Prefab</h2>
        <hr />
        <p>
          Voluptates omnis natus illum magnam harum eum. Dolor dicta rerum ut
          hic sint nulla. Quo eum quidem ad harum beatae nostrum. Officia in
          quis minima totam maxime. Provident sint excepturi doloribus
          repudiandae repellendus quasi.
        </p>
        <p>
          Voluptates omnis natus illum magnam harum eum. Dolor dicta rerum ut
          hic sint nulla. Quo eum quidem ad harum beatae nostrum. Officia in
          quis minima totam maxime. Provident sint excepturi doloribus
          repudiandae repellendus quasi.
        </p>
      </div>
    </div>
  );
}
